import Header from "../../Shared-Component/Header/Header"
import Footer from "../../Shared-Component/Footer/Footer"
import "../AdmissionCommittee/AdmissionCommittee.scss"
import { useState } from 'react'
import "../../CampusLife/CampusSharedComponent/CampusViewMore/CampusViewMore.scss"
import Lines from '../../components/Lines'
import TableComponent from '../../components/Table/TableComponent'


const AdmissionCommittee = () => {
    const [showContent, setShowContent] = useState(false);

    const columns = ["S.No.", "Name", "Designation & Department", "Position", "Email ID"];
    const rows = [
        { name: "Dr. R. Marimuthu", designDept: "Principal", pos: "Chairman", emailId: "nicollege2001@yahoo.co.in" },
        { name: "Dr. R. Rajalakshmi", designDept: "Asst. Prof. & Head, Department of Computer Science (PG)", pos: "Member", emailId: "rajalakshminatesh@gmil.com" },
        { name: "Mrs. S. T. Deepa", designDept: "Asst. Prof. & Head, Department of Information Technology (UG)", pos: "Member", emailId: "deepapramod1972@gmail.com" },
        { name: "Dr. S. Padma Devi", designDept: "Asst. Prof. & Head, Department of Tamil", pos: "Member", emailId: "padma101978@gmail.com" },
        { name: "Mrs. K. Viji", designDept: "Technical Assistant", pos: "Member", emailId: "vg851104@gmail.com" },

    ]


    return (
        <>
            <div className="header">
                <Header />
            </div>

            <div className="main-container">
                <div className='admissionPageMainContainer main-content'>
                    <header className="admissionCommitteeHeader">
                        <h2 style={{ color: "#116C4A" }}>Admission Committee</h2>
                        <span className="lines-parent">
                            <Lines count={25} color="#116C4A" fontSize={2.3} spacing={0.1} thickness={700} />
                        </span>
                    </header>
                    <p className='comm-content'>
                        The Admission Committee at Noorul Islam College of Arts & Science is constituted to ensure a fair, transparent  admission process in alignment with the institution’s mission of academic excellence, inclusivity, and holistic development. The committee focuses to evaluate candidates based on academic qualifications, reservation norms, and program-specific requirements. Ensure all admissions are made in compliance with university regulations and reservation policies. Maintain transparency throughout the admission process and uphold ethical standards in decision-making. Provide accurate and timely information regarding courses, eligibility, fees, and admission deadlines.
                    </p>
                    <TableComponent
                        columns={columns}
                        data={rows}
                        title="Admission Committee"
                        gap='20px'
                    />
                </div>
            </div>

            <div>
                <Footer />
            </div>
        </>
    )
}

export default AdmissionCommittee